import React from 'react';

export const VolLocNewNumModal = {
  title: 'Volcano Number',
  body: (
    <div>
      <p>
        Smithsonian Global Volcanism Program (GVP) provides permanent unique
        identifiers (Volcano Numbers) for volcanoes documented in the Volcanoes
        of the World (VOTW) database maintained by GVP.  For more information on
        the volcano number, please visit Smithsonian Institution,
        Global Volcanism Program.
      </p>
    </div>
  ),
};
